module.exports = __webpack_public_path__ + "img/Judith.f1760204.jpg";